import '../css/main.css';

import 'flickity/css/flickity.css';

import 'lazysizes';


if (!String.prototype.includes) {
  String.prototype.includes = function() {
    'use strict';
    return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}
if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}


if (!Object.entries) {
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}


import 'promise-polyfill/src/polyfill';

// var imagesLoaded = require('imagesloaded');
import imagesLoaded from 'imagesloaded';

// var $ = require('jquery');
import $ from 'jquery';

window.$ = $;
// import lazySizes, {
//   init
// } from 'lazysizes';
// import 'lazysizes/plugins/respimg/ls.respimg';

// lazySizes.cfg.expand = 500;
// lazySizes.cfg.expFactor = 2;
// lazySizes.cfg.loadMode = 3;

// import barba from '@barba/core';

import 'scroll-restoration-polyfill';

import Player from '@vimeo/player';

window.ScrollTrigger = ScrollTrigger;

import {
  gsap
} from "gsap";

gsap.config({
  force3D: true
});

import {
  TweenMax,
  TimelineMax
} from "gsap";
import {
  ScrollToPlugin
} from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
window.gsap = gsap;

import Flickity from 'flickity';
// import Plyr from 'plyr';
// import Plyr from 'plyr/dist/plyr.polyfilled';

import Swup from 'swup';
import SwupJsPlugin from '@swup/js-plugin';


import {
  ScrollTrigger
} from "gsap/ScrollTrigger";

// lazySizes.cfg.preloadAfterLoad = true;

gsap.registerPlugin(ScrollTrigger);

function onDone() {

}


const options = [
  {
    from: '(.*)',
    to: '(.*)',
    in: function(next) {
      if ($('#swup').data('barba-namespace') == 'project') {
        var items = document.querySelectorAll('.single-project__intro img');
        imgLoad = imagesLoaded(items);
        imgLoad.on('done', function() {
          gsap.to($('.site-overlay'), {
            x: "100%",
            onComplete: function() {
              // done();

              gsap.set($('.site-overlay'), {
                x: "-100%",
                skewX: "10deg",
                visibility: "hidden"
              });
              next();
            },
            duration: 0.5
          });
          imgLoad.off();

        });

      } else if ($('#swup').data('barba-namespace') == 'work') {
        var items = document.querySelectorAll('.c--work-grid__item img');

        imgLoad = imagesLoaded(items);
        imgLoad.on('done', function() {
          gsap.to($('.site-overlay'), {
            x: "100%",
            onComplete: function() {
              // done();

              gsap.set($('.site-overlay'), {
                x: "-100%",
                skewX: "10deg",
                visibility: "hidden"
              });
              next();
            },
            duration: 0.5
          });
          imgLoad.off();
        });


      } else {

        gsap.to($('.site-overlay'), {
          x: "100%",
          onComplete: function() {
            // done();

            gsap.set($('.site-overlay'), {
              x: "-100%",
              // skewX: "10deg",
              visibility: "hidden"
            });
            next();
          },
          duration: 0.5
        });
      }
    },
    out: (next) => {
      gsap.set($('.site-overlay'), {
        visibility: 'visible'
      });
      gsap.to($('.site-overlay'), {
        x: "0%",
        skewX: "0deg",
        duration: 0.5,
        onComplete: function() {
          gsap.to(window, 0, {
            scrollTo: 0
          });
          next();
        }
      });
      // alert('prev complete');
      // done();
    }
  }
];


// $(document).ready(function () {
var scrollTriggerInstance;
var scrollTriggerInstance2;
var scrollTriggerInstanceAbout;
var scrollTriggerInstanceAbout2;

var scrollTriggerInstanceProject;
// var scrollTriggerInstanceFooter;

var scrollTriggerInstanceVideos = [];

var plyrInstances = [];


// var plyrHomeInstance;
var plyrHomePlayer;
window.plyrHomePlayer = plyrHomePlayer;

var flickityInstances = [];
var imgLoad;
var contactMap = {};
var aboutPlayer;
var aboutAnimate = 0;

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Barba.Dispatcher.on('newPageReady', function(current, prev, container) { history.scrollRestoration = 'manual'; });


document.addEventListener("click", function(evt) {
  if ($('.site-menu').hasClass('active')) {

    var flyoutElement = document.getElementsByClassName('site-menu'),
      targetElement = evt.target; // clicked element

    do {
      if (($(evt.target).hasClass('site-menu')) || ($(evt.target).hasClass('hamburger')) || ($(evt.target).hasClass('hamburger-box')) || ($(evt.target).hasClass('hamburger-inner')) || (targetElement == flyoutElement)) {
        return;
      }
      // Go up the DOM
      targetElement = targetElement.parentNode;
    } while (targetElement);

    // This is a click outside.
    if ($(window).innerWidth() > 600) {
      $hamburger.toggleClass("is-active");
      $('.site-menu').toggleClass('active');
    }
  }
});

var $hamburger = $(".hamburger");
$hamburger.on("click", function(e) {
  $('.site-menu').addClass('transition');
  $hamburger.toggleClass("is-active");
  $('.site-menu').toggleClass('active');


  // gsap.fromTo('line.stheader', {
  //   attr: {
  //     x2: 0
  //   }
  // }, {
  //   attr: {
  //     x2: 19
  //   },
  //   duration: 0.8,
  //   stagger: 0.1
  // });


  // gsap.fromTo('polyline.stheader', {
  //   x: -20
  // }, {
  //   x: 0,
  //   duration: 0.8,
  //   stagger: 0.1
  // });

});

function doWorkGrid() {

  // doColcade();

  // if ($('.site-main').data('barba-namespace') == 'work') {
  //   if ($(window).innerWidth() > 600) {

  //     $('.c--work-grid__col').each(function (index, el) {
  //       let $items = $(el).find('.c--work-grid__item');
  //       gsap.to($items, {
  //         opacity: 1,
  //         delay: 0.3,
  //         y: 0,
  //         stagger: 0.2
  //       });

  //     });
  //   } else {
  //     gsap.to('.c--work-grid__item', {
  //       opacity: 1,
  //       y: 0,
  //       stagger: 0.2
  //     });
  //   }
  // }


  $('.c--work-grid__item').each(function(index, el) {

    var tl = gsap.timeline({});
    tl.fromTo($(el).find('.c--work-grid__item__inner'), {
      // opacity: 0
      clipPath: "inset(0% 0% 100% 0%)"
    }, {
      // opacity: 1,
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 0.4
    })
    tl.to($(el).find('.c--work-grid__item__title span'), {
      y: 0,
      opacity: 1,
      duration: 0.4
    }, '-=0.3');
    tl.to($(el).find('.c--work-grid__item__tagline span'), {
      y: 0,
      opacity: 1,
      duration: 0.4
    }, '-=0.4');
    tl.to($(el).find('.c--work-grid__item__arrow svg'), {
      scale: 1,
      duration: 0.3
    }, '-=0.4');
    tl.pause();

    function tlPlay() {
      tl.play();
    }

    function tlReverse() {
      tl.reverse();
    }


    if ($(window).innerWidth() <= 768) {

      $(el).on('touchmove', tlPlay);
      $(el).on('touchend', tlReverse);

    } else {
      $(el).on('mouseenter', tlPlay);
      $(el).on('mouseleave', tlReverse);
      // el.addEventListener('touchmove', tlPlay, {
      //   passive: true
      // });
      // el.addEventListener('touchend', tlReverse, {
      //   passive: true
      // });

    }
  })


}

function doTestimonialCarousel(multiple) {
  if (multiple) {
    $('.js--testimonial-carousel').each(function(index, el) {
      var flickityInstance = new Flickity(el, {
        // options
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,

        imagesLoaded: true
      });
      flickityInstances.push(flickityInstance);
    })

  } else {
    $('.js--testimonial-carousel').each(function(index, el) {
      var flickityInstance = new Flickity(el, {
        // options
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        imagesLoaded: true
      });
      flickityInstances.push(flickityInstance);
    })

  }
  ScrollTrigger.refresh();
}

function doScrollArrow() {

  var tl = gsap.timeline({
    repeat: -1,
    repeatDelay: 0
  });
  tl.fromTo('.c--home-intro__arrow', {
      // opacity: 0
      // clipPath: "inset(0% 0% 100% 0%)"
      scale: 0,
    }, {
      // opacity: 1,
      // clipPath: "inset(0% 0% 0% 0%)",
      scale: 1,
      duration: 1
    })
    .fromTo('.c--home-intro__arrow', {
      // opacity: 0
      clipPath: "inset(0% 0% 0% 0%)"
    }, {
      // opacity: 1,
      clipPath: "inset(100% 0% 0% 0%)",
      duration: 0.25,
      delay: '1'
    })


  $('.c--home-intro__arrow').click(function(e) {
    e.preventDefault();
    gsap.to(window, 0.5, {
      scrollTo: '.js--arrow-target'
    });
  })
}

function workCompleted() {
  doWorkGrid();
  $('.hamburger').addClass('hamburger--black');

  // scrollTriggerInstance = ScrollTrigger.create({
  //   trigger: ".site-main__inner",
  //   start: "bottom top+=70",
  //   end: "bottom top-=2000",
  //   onToggle: self => {
  //     $('.hamburger').toggleClass('hamburger--black');
  //   }
  // });

  $('video').each(function(index, el) {
    $(el)[0].play();
  })
}

function articleCompleted() {
  $('.hamburger').addClass('hamburger--black');

  $('video').each(function(index, el) {
    $(el)[0].play();
  })

  document.querySelectorAll('.c--article-arrow-wrapper').forEach(function(el) {
    var tl = gsap.timeline({});
    tl.fromTo(el.querySelector('.c--article-arrow'), {scale: 0}, {
      scale: 1,
      duration: 0.3
    });
    tl.pause();

    el.addEventListener('mouseenter', function(e) {
      tl.play();
    });
    el.addEventListener('mouseleave', function(e) {
      tl.reverse();
    });
  })

}


function aboutCompleted() {
  doScrollArrow();
  animateClients();
  animateAwards();
  setTimeout(function() {
    doTestimonialCarousel(true);
  }, 500);


  gsap.to('.p--about__intro h1', {
    opacity: 1,
    y: 0,
    duration: 0.6
  });


  $(".p--about--animate").each(function(index, el) {
    gsap.to(el, {
      opacity: 1,
      y: 0,
      scrollTrigger: {
        id: 'st-animate' + index,
        trigger: el, // start the animation when ".box" enters the viewport (once)
        start: "top center+=" + $(window).innerHeight() / 3
      },
    });
    aboutAnimate++;

  });


  gsap.to('.p--about__brand__col', {
    opacity: 1,
    y: 0,
    stagger: 0.4,
    scrollTrigger: {
      id: 'st-animate-brand',
      trigger: '.p--about__brand', // start the animation when ".box" enters the viewport (once)
      start: "top center+=" + $(window).innerHeight() / 3
    },
  });


  $('.hamburger').addClass('hamburger--hover-black');

  scrollTriggerInstance = ScrollTrigger.create({
    trigger: ".p--about__main",
    start: "top top+=70",
    end: "bottom top+=70",
    onToggle: self => {
      $('.hamburger').toggleClass('hamburger--black');
    }
  });

  scrollTriggerInstance2 = ScrollTrigger.create({
    trigger: ".p--about__brand",
    start: "top top+=70",
    end: "bottom top+=70",
    onToggle: self => {
      $('.hamburger').toggleClass('hamburger--black');
    }
  });

  scrollTriggerInstanceAbout = ScrollTrigger.create({
    trigger: ".p--about__brand",
    start: "top top+=70",
    end: "bottom top+=70",
    onEnter: self => {
      $('.hamburger').addClass('hamburger--hover-black');
    },
    onEnterBack: self => {
      $('.hamburger').addClass('hamburger--hover-black');
    },
    onLeave: self => {
      $('.hamburger').removeClass('hamburger--hover-black');
    },
    onLeaveBack: self => {
      $('.hamburger').removeClass('hamburger--hover-black');
    },
  });

  scrollTriggerInstanceAbout2 = ScrollTrigger.create({
    trigger: ".p--about__intro",
    start: "top top",
    end: "bottom top+=70",
    onEnter: self => {
      $('.hamburger').addClass('hamburger--hover-black');
    },
    onEnterBack: self => {
      $('.hamburger').addClass('hamburger--hover-black');
    },
    onLeave: self => {
      $('.hamburger').removeClass('hamburger--hover-black');
    },
    onLeaveBack: self => {
      // $('.hamburger').removeClass('hamburger--hover-black');
    },
  });

  // plyrAboutInstance = new Plyr('#player', {
  //   autoplay: true,
  //   autopause: false,
  //   muted: true,
  //   volume: 0,
  //   controls: [],
  //   clickToPlay: false,
  //   loop: {
  //     active: true
  //   }
  // });
  // plyrAboutInstance.on('ready', event => {
  //   ScrollTrigger.refresh();
  // });
  var player = document.querySelector('#player');
  var options01 = {
    id: $('#player').data('vimeo').replace('https://vimeo.com/', ''),
    width: 800,
    controls: false,
    autoplay: true,
    background: true,
    autopause: false,
    muted: true,
    playsinline: true
  };


  aboutPlayer = new Player(player, options01);
}


function calculateHomeVideo() {
  if ($(window).innerWidth() > 600) {
    var videoHeight = 56.25 / 100 * $(window).innerWidth();
    var scale = 1.05 * $(window).innerHeight() / videoHeight;


    if (scale > 1) {
      // gsap.set('.c--home-intro .plyr', {
      //   scale: scale
      // })
      // gsap.set('.c--home-intro .plyr__video-wrapper', {
      //   y: '0%'
      // });
      gsap.set('.c--home-intro #player', {
        scale: scale,
        height: '100%',
        y: '0%'
      })

    } else {
      let verticalAlignment = (1 - scale) * 100 / 2;
      // gsap.set('.c--home-intro .plyr__video-wrapper', {
      //   y: '-' + verticalAlignment + '%'
      // });
      gsap.set('.c--home-intro #player', {
        scale: 1.05
      })
      gsap.set('.c--home-intro #player', {
        height: '56.25vw'
      })
      gsap.set('.c--home-intro #player', {
        y: '-' + verticalAlignment + '%'
      });
      // gsap.set('.c--home-intro .plyr', {
      //   scale: 1.05
      // })
    }
  } else {
    gsap.set('.c--home-intro #player', {
      scale: 1,
      y: '0%'
    })
  }
}

let introParallax;

function calculateIntroParallax() {
  if ($(window).innerWidth() > 600) {
    // scrollTriggerInstanceFooter = ScrollTrigger.create({
    //   trigger: ".site-main__inner",
    //   id: 'st-homefooter',
    //   start: "top bottom",
    //   end: "top top",
    //   onToggle: function ({
    //     progress,
    //     direction,
    //     isActive
    //   }) {
    //     if (direction == 1 && !isActive) {
    //       $('.site-footer').css('z-index', 1);
    //       $('.js--intro').css('z-index', 0);
    //     }
    //     if (direction == -1 && isActive) {
    //       $('.site-footer').css('z-index', 0);
    //       $('.js--intro').css('z-index', 1);
    //     }
    //   }
    // });


    if (ScrollTrigger.getById('st-home-intro-parallax') !== undefined) {
      ScrollTrigger.getById('st-home-intro-parallax').kill();
    }
    introParallax = gsap.to('.js--intro #player', {
      yPercent: "-70",

      ease: "none",
      scrollTrigger: {
        id: 'st-home-intro-parallax',
        trigger: ".single-project__main", // start the animation when ".box" enters the viewport (once)
        start: "top bottom",
        end: "top top",
        scrub: true
      }
    })
  } else {
    gsap.set('.js--intro video, #player', {
      yPercent: "-50",
    })
  }
}

let homePlayer;

function initHomeVideo() {

  if ($(window).innerWidth() > 600) {

    // plyrHomeInstance = new Plyr('#player', {
    //   autoplay: true,
    //   autopause: false,
    //   muted: true,
    //   volume: 0,
    //   controls: [],
    //   clickToPlay: false,
    //   loop: {
    //     active: true
    //   }
    // });
    // plyrHomeInstance.on('ready', event => {
    //   plyrHomeInstance.play()
    // });
    // plyrHomeInstance.on('playing', event => {
    //   setTimeout(function () {
    //     $('.c--home-intro .plyr__video-wrapper').css('opacity', 1);
    //   }, 150);
    // });

    var player = document.querySelector('#player');
    var options01 = {
      id: $('#player').data('vimeo'),
      width: 800,
      controls: false,
      autoplay: true,
      background: true,
      autopause: false,
      muted: true,
      playsinline: true
    };

    window.plyrHomePlayer = new Player(player, options01);


  } else {
    // plyrHomeInstance = new Plyr('#mobile-player', {
    //   autoplay: true,
    //   autopause: false,
    //   muted: true,
    //   volume: 0,
    //   controls: [],
    //   clickToPlay: false,
    //   loop: {
    //     active: true
    //   }
    // });

    // plyrHomeInstance.on('ready', event => {
    //   plyrHomeInstance.play()
    // });
    // plyrHomeInstance.on('playing', event => {
    //   $('.c--home-intro .plyr__video-wrapper').css('opacity', 1);
    // });

    var player = document.querySelector('#mobile-player');
    var options01 = {
      id: $('#mobile-player').data('vimeo'),
      width: 800,
      controls: false,
      autoplay: true,
      background: true,
      autopause: false,
      muted: true,
      playsinline: true
    };

    window.plyrHomePlayer = new Player(player, options01);

  }
}


var resizeTimer;

$(window).on('resize', function(e) {

  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    if ($('.site-main').data('barba-namespace') == 'home') {

      calculateHomeVideo();
      calculateIntroParallax();

    }

  }, 250);

});


var homeScene;

function homeCompleted() {
  doWorkGrid();
  setTimeout(function() {
    doTestimonialCarousel();
  }, 500);
  doScrollArrow();
  animateClients();


  let $children = $('.c--home-intro-text__child');
  gsap.to($children, {
    opacity: 1,
    y: 0,
    stagger: 0.2,
    scrollTrigger: {
      id: 'st-home-intro',
      trigger: '.c--home-intro-text', // start the animation when ".box" enters the viewport (once)
      toggleActions: 'play none play none',
      start: "top center+=" + $(window).innerHeight() / 3
    },
  });


  gsap.to('.c--home__bright', {
    opacity: 1,
    y: 0,
    scrollTrigger: {
      id: 'st-home-bright',
      trigger: '.c--home__bright', // start the animation when ".box" enters the viewport (once)
      start: "top center+=" + $(window).innerHeight() / 3
    },
  });
  gsap.to('.c--home__bright__inner div', {
    opacity: 1,
    y: 0,
    stagger: 0.2,
    scrollTrigger: {
      id: 'st-home-bright2',
      trigger: '.c--home__bright__inner', // start the animation when ".box" enters the viewport (once)
      start: "top center+=" + $(window).innerHeight() / 3
    },
  });


  gsap.fromTo('line.st0discover', {
    attr: {
      x2: 0
    }
  }, {
    attr: {
      x2: 19
    },
    stagger: 0.1,
    scrollTrigger: {
      id: 'st-home-discover',
      trigger: ".c--home__bright", // start the animation when ".box" enters the viewport (once)
      start: "top top"
    }
  });
  gsap.fromTo('polyline.st0discover', {
    x: -20
  }, {
    x: 0,
    stagger: 0.1,
    scrollTrigger: {
      id: 'st-home-discover2',
      trigger: ".c--home__bright", // start the animation when ".box" enters the viewport (once)
      start: "top top"
    }
  });


  ScrollTrigger.create({
    id: 'st-hamburger',
    trigger: ".site-main__inner",
    start: "top top+=70",
    end: "bottom top+=70",
    onToggle: self => {
      $('.hamburger').toggleClass('hamburger--black');
    }
  });

  initHomeVideo();
  // calculateHomeVideo();
  // calculateIntroParallax();

  $('.c--home-intro__video').each(function(index, el) {
    $(el)[0].play();
  })


}

let footerTween;

function defaultAfterEnter() {
  gsap.to(window, 0, {
    scrollTo: 0
  });
  window.dispatchEvent(new Event('resize'));


  // $(".c--testimonial-wrapper ").each(function (index, el) {
  //   gsap.to(el, {
  //     opacity: 1,
  //     y: 0,
  //     scrollTrigger: {
  //       trigger: el, // start the animation when ".box" enters the viewport (once)
  //       start: "top center+=" + $(window).innerHeight() / 3
  //     },
  //   });
  // })
  if (($('#swup').data('barba-namespace') != 'contact') && ($(window).innerWidth() > 768)) {

    // var screenHeight = $(window).innerHeight();
    // gsap.to('.site-footer', {
    //   y: 0,
    //   ease: "none",
    //   scrollTrigger: {
    //     id: 'st-footer-reveal',
    //     trigger: ".site-main__inner", // start the animation when ".box" enters the viewport (once)
    //     start: "bottom bottom+=" + screenHeight + 'px',
    //     end: "bottom bottom",
    //     scrub: true
    //   }
    // });

    var fromFooter = 17.5 * parseFloat(getComputedStyle(document.documentElement).fontSize) + $('.site-footer__inner').innerHeight();

    gsap.fromTo(".site-footer__inner", {
      y: -fromFooter
    }, {
      y: 0,
      ease: "none",
      scrollTrigger: {
        id: 'st-footer1',
        trigger: ".site-footer", // start the animation when ".box" enters the viewport (once)
        start: "top bottom",
        end: () => '+=' + $('.site-footer').innerHeight(),
        scrub: true,
        ease: "none"
        // snap: 0.4
      }
    });


    gsap.fromTo('line.st0footer', {
      attr: {
        x2: 0
      }
    }, {
      attr: {
        x2: 19
      },
      stagger: 0.1,
      scrollTrigger: {
        id: 'st-footer2',
        trigger: ".site-footer", // start the animation when ".box" enters the viewport (once)
        start: "top bottom-=" + $('.site-footer').innerHeight() / 2,
        end: '+=' + $('.site-footer').innerHeight() / 2,
        scrub: false
      }
    });
    gsap.fromTo('polyline.st0footer', {
      x: -20
    }, {
      x: 0,
      stagger: 0.1,
      scrollTrigger: {
        id: 'st-footer3',
        trigger: ".site-footer", // start the animation when ".box" enters the viewport (once)
        start: "top bottom-=" + $('.site-footer').innerHeight() / 2,
        end: '+=' + $('.site-footer').innerHeight() / 2,

        scrub: false
      }
    });

  }

  if ($('.site-main').data('barba-namespace') == 'contact') {
    $('.site-menu').addClass('has-shadow');
  } else {
    $('.site-menu').removeClass('has-shadow');
  }


}

let projectFooterTween;
let parallaxLogoTween;

function projectCompleted() {
  setTimeout(function() {
    doTestimonialCarousel();

  }, 500);

  scrollTriggerInstanceProject = ScrollTrigger.create({
    trigger: ".site-main__inner",
    start: "top top+=70",
    end: "bottom top+=70",
    onToggle: self => {
      // alert('toggling');
      $('.hamburger').toggleClass('hamburger--black');
    }
  });

  // scrollTriggerInstanceFooter = ScrollTrigger.create({
  //   trigger: ".single-project__main",
  //   start: "top bottom",
  //   end: "top top",
  //   onToggle: function ({
  //     progress,
  //     direction,
  //     isActive
  //   }) {
  //     if (direction == 1 && !isActive) {
  //       $('.site-footer').css('z-index', 1);
  //       $('.js--intro').css('z-index', 0);
  //     }
  //     if (direction == -1 && isActive) {
  //       $('.site-footer').css('z-index', 0);
  //       $('.js--intro').css('z-index', 1);
  //     }
  //   }
  // });
  // scrollTriggerInstanceFooter = ScrollTrigger.create({
  //   trigger: ".site-main__inner",
  //   start: "bottom bottom+=100vh",
  //   end: "bottom bottom",
  //   onToggle: function ({
  //     progress,
  //     direction,
  //     isActive
  //   }) {
  //     if (direction == 1 && !isActive) {
  //       $('.site-footer').css('z-index', 1);
  //       $('.js--intro').css('z-index', 0);
  //     }
  //     if (direction == -1 && isActive) {
  //       $('.site-footer').css('z-index', 0);
  //       $('.js--intro').css('z-index', 1);
  //     }
  //   }
  // });


  if ($(window).innerWidth() > 768) {
    // projectFooterTween.kill();
    projectFooterTween = gsap.to('.single-project__intro .c--picture', {
      yPercent: "-20",
      ease: "none",
      scrollTrigger: {
        id: 'st-project-footer',
        trigger: ".single-project__main", // start the animation when ".box" enters the viewport (once)
        start: "top bottom",
        end: "top top",
        scrub: true
      }
    })

    parallaxLogoTween = gsap.fromTo('.single-project__intro .c--picture__logo', {
        yPercent: "-50"
      },
      {
        yPercent: "-120",
        ease: "none",
        scrollTrigger: {
          id: 'st-project-footer',
          trigger: ".single-project__main", // start the animation when ".box" enters the viewport (once)
          start: "top bottom",
          end: "top top",
          scrub: true
        }
      })
  }

  $('.c--content-block--slideshow__inner').each(function(index, el) {
    var flickityInstance = new Flickity(el, {
      // options
      prevNextButtons: true,
      pageDots: true,
      wrapAround: true,
      imagesLoaded: true
    });
    flickityInstances.push(flickityInstance);
  })

  $('.c--video').each(function(el) {
    // $(this).get(0).play();
    var $this = $(this);
    $this.get(0).pause();
    // $this.get(0).pause();
    scrollTriggerInstance = ScrollTrigger.create({
      trigger: $this,
      start: "top center+=" + $(window).innerHeight() / 3,
      onEnter: self => {
        // alert('playin gi');
        $this.get(0).play();
        ScrollTrigger.refresh();
      }
    });
    scrollTriggerInstanceVideos.push(scrollTriggerInstance);
  })

  $('.c--content-block--video__video').each(function(index, el) {
    var color = $(el).data('color').replace('#', '');
    let autoplay = $(el).data('autoplay');
    // var player = document.querySelector(el);
    var options01 = {
      url: $(el).data('vimeo'),
      width: 800,
      controls: autoplay ? false : true,
      autoplay: false,
      background: autoplay ? true : false,
      muted: autoplay ? true : false,
      title: false,
      byline: false,
      color: color,
      autopause: false,
      portrait: false
    };


    var projPlayer = new Player(el, options01);

    plyrInstances.push(projPlayer);
  })


}


function initMap() {
  if (Object.keys(contactMap).length === 0) {
    var myLatLng = {
      lat: 51.602331,
      lng: -0.144065
    };

    const markerCircle = {
      path: 'M37.3,18.7c0,10.3-8.4,18.7-18.7,18.7S0,29,0,18.7S8.4,0,18.7,0S37.3,8.4,37.3,18.7z',
      fillColor: '#ff4628',
      fillOpacity: 1,
      strokeWeight: 0,
      //scale: 0.35,
      anchor: new google.maps.Point(32, 32)
    };

    let disableDefaultUI = false;
    let gestures = 'greedy';
    if ($(window).innerWidth() <= 600) {
      disableDefaultUI = true;
      gestures = 'cooperative';
    }
    contactMap = new google.maps.Map(document.getElementById('map'), {
      center: myLatLng,
      zoom: 15,
      scrollwheel: false,
      disableDefaultUI: disableDefaultUI,
      // gestureHandling: 'cooperative',
      options: {
        gestureHandling: gestures
      },
      styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#c9c9c9"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ]
    });

    var marker = new google.maps.Marker({
      position: myLatLng,
      map: contactMap,
      title: 'HelloYes',
      icon: markerCircle
    });

    marker.addListener("click", () => {
      window.open("https://goo.gl/maps/v31kwFEQcW9KBCG18");

    });
  } else {
    let mapnode = contactMap.getDiv();
    $('.c--contact-map').append(mapnode);

  }
}

function animateClients() {
  let $children = $('.c--clients__item');
  gsap.to($children, {
    opacity: 1,
    y: 0,
    stagger: 0.1,
    scrollTrigger: {
      id: 'st-clients',
      trigger: '.c--clients__items', // start the animation when ".box" enters the viewport (once)
      toggleActions: 'play none play none',
      start: "top center+=" + $(window).innerHeight() / 3
    },
  });
}

function animateAwards() {
  document.querySelectorAll('.p--about__awards__blocks').forEach(function(el) {
    let $children = $(el).find('.p--about__awards__blocks__item');
    gsap.to($children, {
      opacity: 1,
      y: 0,
      stagger: 0.1,
      scrollTrigger: {
        id: 'st-awards',
        trigger: $(el), // start the animation when ".box" enters the viewport (once)
        toggleActions: 'play none play none',
        start: "top center+=" + $(window).innerHeight() / 3
      },
    });
  });

}

function staticCompleted() {
  $('.hamburger').addClass('hamburger--black');
}

function contactCompleted() {
  $('.hamburger').addClass('hamburger--black');
  if ($(window).innerWidth() > 1000) {
    gsap.fromTo(".c--contact-map", {
      y: "300"
    }, {
      y: "0",
      ease: "none",
      scrollTrigger: {
        trigger: ".site-main__inner", // start the animation when ".box" enters the viewport (once)
        start: "bottom bottom",
        end: '+=' + $('.c--contact-map').innerHeight(),

        scrub: true
      }
    });
  }
  if (typeof google === 'object' && typeof google.maps === 'object') {
    initMap();
  } else {
    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDtFUxJC-fEf0x_EOlcrP4f-wdeoToxbFk&callback=initMap';
    script.defer = true;
    script.async = true;
    // Attach your callback function to the `window` object
    // Append the 'script' element to 'head'
    document.head.appendChild(script);
  }
  window.initMap = function() {
    // JS API is loaded and available
    initMap();
  };

  var tl = gsap.timeline({
    repeat: -1,
    repeatDelay: 0
  });
  tl.fromTo('.c--contact__arrow', {
      // opacity: 0
      // clipPath: "inset(0% 0% 100% 0%)"
      scale: 0,
    }, {
      // opacity: 1,
      // clipPath: "inset(0% 0% 0% 0%)",
      scale: 1,
      duration: 1
    })
    .fromTo('.c--contact__arrow', {
      // opacity: 0
      clipPath: "inset(0% 0% 0% 0%)"
    }, {
      // opacity: 1,
      clipPath: "inset(100% 0% 0% 0%)",
      duration: 0.25,
      delay: '1'
    })


  $('.js--show-map').click(function(e) {
    e.preventDefault();
    gsap.to(window, 0.5, {
      scrollTo: {
        y: "max"
      }
    });
  })
}


// var controller = new ScrollMagic.Controller();


// let enter_logo = gsap.to('.header__logo', .6, {
//   opacity: 1
// });

// homeScene = new ScrollMagic.Scene({
//     // triggerElement: ".c--home-intro-text",
//     // triggerHook: "onLeave",
//     reverse: true
//   })
//   // .setTween(enter_logo)
//   .addTo(controller);

// homeScene.on("progress", function (event) {
//   console.log("Scene progress changed to " + event.progress);
// });

window.onscroll = function(e) {
  if ((this.oldScroll > this.scrollY) && (this.scrollY != 0)) {
    $('.header__logo').addClass('show');
  } else {
    if ($('.header__logo').hasClass('header__logo--show') && this.scrollY == 0) {

    } else {
      $('.header__logo').removeClass('show');
    }
  }

  // if ((this.oldScroll < this.scrollY)) {
  //   $('.header__logo').removeClass('header__logo--show');
  // }

  this.oldScroll = this.scrollY;
}


// let durationBarba = 0.4;
// barba.hooks.beforeLeave((data) => {
//   // controller.removeScene(homeScene);
//   // ScrollTrigger.kill();
//   if ($('.hamburger').hasClass('is-active')) {
//     $('.hamburger').click();
//   }
// });

// barba.hooks.afterEnter((data) => {
//   // this hook will be called for each transitions
//   defaultAfterEnter();
// });
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (isIE11) {
  $('body').addClass('ie11');
}

// barba.init({
//   debug: false,
//   cacheIgnore: false,
//   prevent: function () {
//     if (isIE11) {
//       return true;
//     }
//   },
//   transitions: [{
//     name: 'room',
//     sync: false,
//     leave({
//       current,
//       trigger
//     }) {

//       // const done = this.async();
//       return new Promise(async resolve => {
//         // scrollTriggerInstanceProject.kill();
//         // scrollTriggerInstanceFooter.kill();
//         $('.header__logo').removeClass('show');

//         if ($(trigger).data('color') != '') {
//           $('.site-overlay').css('background-color', $(trigger).data('color'));
//         } else {
//           $('.site-overlay').css('background-color', '#ffffff');
//         }
//         gsap.set($('.site-overlay'), {
//           visibility: 'visible'
//         });
//         await gsap.to($('.site-overlay'), {
//           x: "0%",
//           skewX: "0deg",
//           duration: 0.5,
//           onComplete: function () {
//             gsap.to(window, 0, {
//               scrollTo: 0
//             });
//             current.container.remove();
//             // alert('prev complete');
//             // done();
//           }
//         }).then();
//         resolve()

//         // gsap.to($(current.container).find('.site-main__inner'), {
//         //   opacity: 0,
//         //   duration: durationBarba,
//         //   onComplete: function () {
//         //     current.container.remove();
//         //     done();

//         //   }
//         // });
//       });
//     },
//     enter({
//       next
//     }) {

//       // if (next.namespace == 'home') {

//       // gsap.set('.header__logo', {
//       //   opacity: 0
//       // });
//       // }
//       return new Promise(resolve => {


//         gsap.to(window, 0, {
//           scrollTo: 0
//         });
//         var that = this;
//         // const done = that.async();

//         // if (next.namespace == 'project') {
//         //   var items = document.querySelectorAll('.single-project__intro img');

//         //   var imgLoad = imagesLoaded(items);
//         //   imgLoad.on('done', onDone);
//         //   async function onDone(instance) {
//         //     try {
//         //       // alert("img done");
//         //       await gsap.to($('.site-overlay'), {
//         //         x: "100%",
//         //         onComplete: function () {
//         //           // alert('complete');
//         //           gsap.set($('.site-overlay'), {
//         //             x: "-100%",
//         //             skewX: "10deg",
//         //             visibility: "hidden"
//         //           })
//         //         },
//         //         duration: 0.5
//         //       }).then();
//         //       resolve()
//         //     } catch (err) {
//         //       console.log(err);
//         //     }
//         //   }
//         // } else if (next.namespace == 'work') {
//         //   var items = document.querySelectorAll('.c--work-grid__item img');

//         //   var imgLoad = imagesLoaded(items);
//         //   imgLoad.on('done', onDone);

//         //   async function onDone(instance) {
//         //     try {
//         //       await gsap.to($('.site-overlay'), {
//         //         x: "100%",
//         //         onComplete: function () {
//         //           gsap.set($('.site-overlay'), {
//         //             x: "-100%",
//         //             skewX: "10deg",
//         //             visibility: "hidden"
//         //           })
//         //         },
//         //         duration: 0.5
//         //       }).then();
//         //       resolve()
//         //     } catch (err) {
//         //       console.log(err);
//         //     }
//         //   }
//         // } else {
//           gsap.to($('.site-overlay'), {
//             x: "100%",
//             onComplete: function () {
//               // done();

//               gsap.set($('.site-overlay'), {
//                 x: "-100%",
//                 skewX: "10deg",
//                 visibility: "hidden"
//               })
//             },
//             duration: 0.5
//           }).then(resolve());


//         // }
//       });
//       // testInTransition(next.container, this.async());

//       // slide(next.container, 'enter', done);
//     },
//     // enter: ({ next }) => slide(next.container, 'enter', 'next'),
//   }, ],
//   views: [{
//       namespace: 'work',
//       afterEnter(data) {
//         workCompleted()
//       },
//       afterLeave() {
//         $('.hamburger').removeClass('hamburger--black');
//         // ScrollTrigger.getById('st-hamburger').kill();
//         $(window).off("resize");

//       }
//     },
//     {
//       namespace: 'project',
//       afterEnter(data) {
//         // workCompleted()
//         projectCompleted();
//       },
//       afterLeave() {
//         // ScrollTrigger.getById('st-hamburger').kill();
//         console.log('killing');
//         // scrollTriggerInstanceProject.kill();
//         // scrollTriggerInstanceFooter.kill();

//         // ScrollTrigger.kill();
//         $('.hamburger').removeClass('hamburger--black');

//       }
//     },
//     {
//       namespace: 'home',
//       afterEnter(data) {
//         homeCompleted();
//       },
//       beforeLeave() {
//         scrollTriggerInstanceFooter.kill();
//       },
//       afterLeave() {
//         $('.hamburger').removeClass('hamburger--black');
//         ScrollTrigger.getById('st-hamburger').kill();
//       }
//     },
//     {
//       namespace: 'about',
//       afterEnter(data) {
//         aboutCompleted()
//       },
//       afterLeave() {
//         $('.hamburger').removeClass('hamburger--black');
//         ScrollTrigger.getById('st-hamburger').kill();
//         scrollTriggerInstance2.kill();
//         scrollTriggerInstanceAbout.kill();
//         scrollTriggerInstanceAbout2.kill();
//       }
//     },
//     {
//       namespace: 'contact',
//       afterEnter(data) {
//         contactCompleted()
//       },
//       afterLeave(data) {
//         $('.hamburger').removeClass('hamburger--black');
//       }
//     }
//   ]
// });

function removeGridListeners() {
  $('.c--work-grid__item').each(function(index, el) {
    $(el).off();
    // el.removeEventListener('touchmove', _touchmove);
    // el.removeEventListener('touchend', _touchend);
  });
}


function initSwup() {
  if ($('#swup').data('barba-namespace') == 'project') {
    defaultAfterEnter();
    $('.header__logo').removeClass('show');
    $('.header__logo').removeClass('header__logo--show');
    projectCompleted();
  }
  if ($('#swup').data('barba-namespace') == 'work') {
    defaultAfterEnter();
    $('.header__logo').removeClass('show');
    $('.header__logo').removeClass('header__logo--show');
    workCompleted();
  }
  if ($('#swup').data('barba-namespace') == 'article') {
    defaultAfterEnter();
    $('.header__logo').addClass('show');
    $('.header__logo').addClass('header__logo--show');
    articleCompleted();
  }
  if ($('#swup').data('barba-namespace') == 'feed') {
    defaultAfterEnter();
    $('.header__logo').addClass('show');
    $('.header__logo').addClass('header__logo--show');
    articleCompleted();
  }
  if ($('#swup').data('barba-namespace') == 'home') {
    defaultAfterEnter();
    $('.header__logo').removeClass('show');
    $('.header__logo').removeClass('header__logo--show');
    homeCompleted();
  }
  if ($('#swup').data('barba-namespace') == 'about') {
    defaultAfterEnter();
    $('.header__logo').addClass('show');
    $('.header__logo').addClass('header__logo--show');
    aboutCompleted();
  }
  if ($('#swup').data('barba-namespace') == 'contact') {
    defaultAfterEnter();
    $('.header__logo').addClass('show');
    $('.header__logo').addClass('header__logo--show');
    contactCompleted();
  }
  if ($('#swup').data('barba-namespace') == 'page') {
    defaultAfterEnter();
    staticCompleted();
  }


  $(".site-footer__address a[href^=\"mailto\"]").click(function(e) {
    // console.log('conversion');
    gtag('event', 'conversion', { 'send_to': 'AW-18244539467/qE__CK-zjMAcEMuo1vtD', 'value': 1.0, 'currency': 'GBP' });
  })
  $(".c--contact__address a[href^=\"mailto\"]").click(function(e) {
    // console.log('conversion contact');
    gtag('event', 'conversion', { 'send_to': 'AW-18244539467/qE__CK-zjMAcEMuo1vtD', 'value': 1.0, 'currency': 'GBP' });
  })

}


function unload() {

  if ($('#swup').data('barba-namespace') == 'project') {
    scrollTriggerInstanceProject.kill();
    // scrollTriggerInstanceFooter.kill();
    // imgLoad.off('done', onDone);

    scrollTriggerInstanceVideos.forEach(function(el) {
      el.kill();
    })

    plyrInstances.forEach(function(player) {
      player.destroy();
    })
    plyrInstances = [];


    ScrollTrigger.getById('st-footer1').kill();
    // ScrollTrigger.getById('st-footer-reveal').kill();
    ScrollTrigger.getById('st-footer2').kill();
    ScrollTrigger.getById('st-footer3').kill();
    if (ScrollTrigger.getById('st-project-footer') !== undefined) {
      ScrollTrigger.getById('st-project-footer').kill();
    }
    $('.hamburger').removeClass('hamburger--black');

    flickityInstances.forEach(function(slideshow) {
      slideshow.destroy();
    })
    flickityInstances = [];
  }

  if ($('#swup').data('barba-namespace') == 'work') {
    // scrollTriggerInstanceProject.kill();
    // scrollTriggerInstanceFooter.kill();
    removeGridListeners();
    // imgLoad.off('done', onDone);
    scrollTriggerInstanceVideos.forEach(function(el) {
      el.kill();
    });
    scrollTriggerInstanceVideos = [];
    ScrollTrigger.getById('st-footer1').kill();
    // ScrollTrigger.getById('st-footer-reveal').kill();
    ScrollTrigger.getById('st-footer2').kill();
    ScrollTrigger.getById('st-footer3').kill();
    $('.hamburger').removeClass('hamburger--black');
    // ScrollTrigger.kill();
  }
  if ($('#swup').data('barba-namespace') == 'home') {
    // ScrollTrigger.kill();
    removeGridListeners();
    window.plyrHomePlayer.destroy();
    ScrollTrigger.getById('st-hamburger').kill();
    ScrollTrigger.getById('st-footer1').kill();
    // ScrollTrigger.getById('st-footer-reveal').kill();
    ScrollTrigger.getById('st-footer2').kill();
    ScrollTrigger.getById('st-footer3').kill();

    ScrollTrigger.getById('st-home-intro-parallax').kill();
    ScrollTrigger.getById('st-home-intro').kill();
    ScrollTrigger.getById('st-home-discover').kill();
    ScrollTrigger.getById('st-home-discover2').kill();
    ScrollTrigger.getById('st-home-bright').kill();
    ScrollTrigger.getById('st-home-bright2').kill();

    ScrollTrigger.getById('st-clients').kill();


    $('.hamburger').removeClass('hamburger--black');

    flickityInstances.forEach(function(slideshow) {
      slideshow.destroy();
    })
    flickityInstances = [];
  }
  if ($('#swup').data('barba-namespace') == 'about') {
    // ScrollTrigger.kill();
    // plyrAboutInstance.destroy();
    aboutPlayer.destroy();
    aboutPlayer = null;

    ScrollTrigger.getById('st-footer1').kill();
    // ScrollTrigger.getById('st-footer-reveal').kill();
    ScrollTrigger.getById('st-footer2').kill();
    ScrollTrigger.getById('st-footer3').kill();

    for (var i = 0; i < aboutAnimate; i++) {

      ScrollTrigger.getById('st-animate' + i).kill();
    }
    aboutAnimate = 0;

    ScrollTrigger.getById('st-animate-brand').kill();
    ScrollTrigger.getById('st-clients').kill();
    ScrollTrigger.getById('st-awards').kill();

    // ScrollTrigger.getById('st-hamburger').kill();
    scrollTriggerInstance.kill();
    scrollTriggerInstance2.kill();
    scrollTriggerInstanceAbout.kill();
    scrollTriggerInstanceAbout2.kill();

    $('.hamburger').removeClass('hamburger--black');

    flickityInstances.forEach(function(slideshow) {
      slideshow.destroy();
    })
    flickityInstances = [];
  }
  if ($('#swup').data('barba-namespace') == 'contact') {
    $('.hamburger').removeClass('hamburger--black');
    // ScrollTrigger.kill();
    // ScrollTrigger.getById('st-footer1').kill();
    // ScrollTrigger.getById('st-footer2').kill();
    // ScrollTrigger.getById('st-footer3').kill();
  }
}


initSwup();

// this event runs for every page view after initial load
if ($(window).innerWidth() > 600) {
  const swup = new Swup({
    plugins: [new SwupJsPlugin(options)]
  });

  swup.on('contentReplaced', initSwup);


  swup.on('willReplaceContent', unload);

  swup.on('clickLink', e => {
    var color = $(e.srcElement).closest('a').data('color');
    if (color != '') {
      $('.site-overlay').css('background-color', color);
    } else {
      $('.site-overlay').css('background-color', '#ff4628');
    }
  });
}


// });